module.exports = __webpack_public_path__ + "img/ingestion_2x.269ce14f.png";